import * as Yup from "yup";

import { AuthKeys, validationMsgs } from "@sso/constant";

export const forgotPasswordValidation = Yup.object({
  [AuthKeys.EMAIL]: Yup.string()
    .required(validationMsgs.required)
    .email(validationMsgs.email)
    .max(100, validationMsgs.maxlength(100)),
});
